import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      try {
        const { data } = await api.post("/auth/refresh");
        setUser(data);
      } catch {
        setUser(false);
      }
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };
  const can = (p) => !!user && user.permissions?.includes(p);

  return <AuthCtx.Provider value={{ user, setUser, logout, can, reload: load }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
